export function getEnumKeyByEnumValue<TEnumKey extends string, TEnumVal extends string | number>(
  enumList: { [key in TEnumKey]: TEnumVal },
  value: TEnumVal,
): string {
  return (Object.keys(enumList) as TEnumKey[]).filter((x) => enumList[x] === value)[0]
}
